// block (our own, not a shadcn upstream block) — not a components/ui primitive.
//
// A content item in a row or a grid: the photo framed on its own (a `media` Card), then the
// title, an optional byline and a timed meta line underneath. `badge` and `corner` tag the
// photo, the default slot draws over it (a play button), and `footer` sits under the copy (a pill). Generic and data-driven: the copy,
// the photo and the link component come in as props or slots. Pass the app's link component as
// `as` to make the whole card the link.
import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as ContentCard } from './ContentCard.vue'

// `size` picks the frame: `row` is the fixed-width row item, `fill` fills its cell with a wide
// photo, and `lead` is a featured block's large lead with a display title.
export const contentCardVariants = cva(
  'group flex shrink-0 flex-col gap-2 rounded-card text-card-foreground focus-visible:outline-3 focus-visible:outline-offset-3 focus-visible:outline-ring',
  {
    variants: {
      size: {
        row: 'w-43 md:w-56',
        fill: 'w-full',
        lead: 'w-full',
      },
    },
    defaultVariants: {
      size: 'row',
    },
  },
)
export type ContentCardVariants = VariantProps<typeof contentCardVariants>

// The photo frame's shape, per card size.
export const contentCardMediaVariants = cva(
  '',
  {
    variants: {
      size: {
        row: 'aspect-6/5',
        fill: 'aspect-video',
        lead: 'aspect-video md:aspect-2/1',
      },
    },
    defaultVariants: {
      size: 'row',
    },
  },
)
